export default "__VITE_ASSET__CDHqK53h__"